export default __webpack_public_path__ + "942a32e26baaed84913286c7cfb04b96.csv";